var _defs, _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPrice1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "price1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 67,
    height: 54.438,
    viewBox: "0 0 67 54.438",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9f78ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.547,
    stopColor: "#f067ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5c33c2"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M67,54.02A6.026,6.026,0,0,0,60.98,48H6.02A6.026,6.026,0,0,0,0,54.02V65.012a5.992,5.992,0,0,0,1.462,3.926A5.992,5.992,0,0,0,0,72.863V83.855a6.026,6.026,0,0,0,6.02,6.02h21.2V98.25H14.656a2.094,2.094,0,0,0,0,4.188H52.344a2.094,2.094,0,1,0,0-4.188H39.781V89.875h21.2A6.026,6.026,0,0,0,67,83.855V72.863a5.992,5.992,0,0,0-1.462-3.926A5.992,5.992,0,0,0,67,65.012Zm-62.812,0A1.834,1.834,0,0,1,6.02,52.188H60.98a1.834,1.834,0,0,1,1.832,1.832V65.012a1.834,1.834,0,0,1-1.832,1.832H6.02a1.834,1.834,0,0,1-1.832-1.832ZM35.594,98.25H31.406V89.875h4.188ZM62.813,83.855a1.834,1.834,0,0,1-1.832,1.832H6.02a1.834,1.834,0,0,1-1.832-1.832V72.863A1.834,1.834,0,0,1,6.02,71.031H60.98a1.834,1.834,0,0,1,1.832,1.832Z",
    transform: "translate(0 -48)",
    fill: "url(#linear-gradient)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M91.141,118.281a3.141,3.141,0,1,1,3.141-3.141A3.144,3.144,0,0,1,91.141,118.281Z",
    transform: "translate(-76.484 -103.625)",
    fill: "url(#linear-gradient)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M91.141,262.281a3.141,3.141,0,1,1,3.141-3.141A3.144,3.144,0,0,1,91.141,262.281Z",
    transform: "translate(-76.484 -228.781)",
    fill: "url(#linear-gradient)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M199.406,124.188H170.094a2.094,2.094,0,0,1,0-4.187h29.312a2.094,2.094,0,1,1,0,4.188Z",
    transform: "translate(-146.016 -110.578)",
    fill: "url(#linear-gradient)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M199.406,268.188H170.094a2.094,2.094,0,0,1,0-4.187h29.312a2.094,2.094,0,1,1,0,4.188Z",
    transform: "translate(-146.016 -235.734)",
    fill: "url(#linear-gradient)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrice1);
export default __webpack_public_path__ + "static/media/price1.b8157278760298e0c761f038ba3a14c3.svg";
export { ForwardRef as ReactComponent };